import React, {Component} from 'react';
import { connect } from 'dva';
import ContactForm from './ContactForm';
import Dimio, {DimioNotice} from '../../../components/Dimio';

class ContactPage extends Component {
  render() {
    const {contact} = this.props;

    return (
      <section id="contact-page" className="page my-2">
        <DimioNotice {...contact} />
        <ContactForm {...this.props} />

        {/* meta.page == 2 &&
        <div>
          <h2>Thank you for subscribing the plan</h2>
          <p>Thankyou message here</p>
        </div>
        */}
      </section>
    );
  }
}

export default connect(({ contact }) => ({
  contact,
}))(ContactPage);


// WEBPACK FOOTER //
// ./src/pages/contact/components/ContactPage.js